const STYLE_ID = "portal-custom-css";

export function applyCustomCss(css) {
    const safeCss = typeof css === "string" ? css : "";

    let el = document.getElementById(STYLE_ID);
    if (!el) {
        el = document.createElement("style");
        el.id = STYLE_ID;
        document.head.appendChild(el);
    }

    el.textContent = safeCss;
}
